export const PAGES = "pages";
export const ANSWERS = "answers";
export const OPTIONS = "options";
export const SECTIONS = "sections";
export const CONFIRMATION = "confirmation";
export const CONFIRMATION_OPTION = "confirmationoption";
